<template>
  <div class="cso-marketing"></div>
</template>

<script>
import LoggingService from '@/common/LoggingService';

export default {
  name: 'CsoMarketing',

  created () {
    if (location.hostname === 'localhost') {
      return
    }
    try {
      this.load()
    } catch (error) {
      LoggingService.error(LoggingService.eventTypes.marketing, 'Loading OneTrust & Piwik failed', error)
    }
  },

  methods: {
    load () {
      /* eslint-disable no-undef, unicorn/dom-node-dataset, unicorn/prefer-dom-node-dataset, sonarjs/no-nested-functions, unicorn/prefer-prototype-methods */
      /*
       * Loader: OneTrust CMP + Piwik PRO Tag Manager
       * Version: 2026-06-23
       */

      const ONETRUST_SCRIPT_URL = 'https://vattenfall-de.my.onetrust.eu/cdn/cookies/scripttemplates/otSDKStub.js';
      const ONETRUST_DOMAIN_SCRIPT_ID = '722792af-ff76-458e-998c-9e7119608fde';
      const ONETRUST_LANGUAGE = 'de';
      const ROOT_DOMAIN = '.vattenfall.de';
      const PIWIK_CONTAINERS = {
        prod: 'b6eacfbe-7660-4775-98a0-2abb109deef8',
        test: 'c70d767d-a03a-4695-b32e-760cc29eb91f'
      };
      const CONSENT_COOKIE_DAYS = 30;
      const COOKIE = {
        vfDebug: 'vf_debug',
        vfConsent: 'vf_cst',
        vfConsentClosed: 'vf_cst_closed',
        optanonConsent: 'OptanonConsent',
        optanonAlertBoxClosed: 'OptanonAlertBoxClosed'
      };

      window.ot_loader = {
        loadOneTrust() {
          const firstScript = document.getElementsByTagName('script')[0];
          const stub = document.createElement('script');
          stub.src = ONETRUST_SCRIPT_URL;
          stub.setAttribute('charset', 'UTF-8');
          stub.setAttribute('data-language', ONETRUST_LANGUAGE);
          stub.setAttribute('data-domain-script', ONETRUST_DOMAIN_SCRIPT_ID);
          firstScript.parentNode.insertBefore(stub, firstScript);
        },

        getContainerId() {
          if (document.cookie?.includes(`${COOKIE.vfDebug}=test`)) {
            return PIWIK_CONTAINERS.test;
          }
          return this.isMainDomain() ? PIWIK_CONTAINERS.prod : PIWIK_CONTAINERS.test;
        },

        isMainDomain() {
        return true;
        },

        getCookie(name) {
          const match = document.cookie?.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
          return match ? match[1] : undefined;
        },

        setCookie(name, value, days, domain) {
          let cookie = `${name}=${value || ''}; path=/`;
          if (days) {
            const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
            cookie += `; expires=${expires.toUTCString()}`;
          }
          if (domain) {
            cookie += `; domain=${domain}`;
          }
          document.cookie = cookie;
        },

        deleteCookie(name, domain) {
          this.setCookie(name, '', -1, domain);
        },

        migrateConsentCookies() {

          if (!this.isMainDomain()) {
            this.deleteCookie(COOKIE.optanonConsent, ROOT_DOMAIN);
            this.deleteCookie(COOKIE.optanonAlertBoxClosed, ROOT_DOMAIN);
            return;
          }

          const vfConsent = this.getCookie(COOKIE.vfConsent);
          const optanonConsent = this.getCookie(COOKIE.optanonConsent);
          if (!vfConsent || optanonConsent) {
            return;
          }

          const vfConsentClosed = this.getCookie(COOKIE.vfConsentClosed);
          this.setCookie(COOKIE.optanonConsent, vfConsent, CONSENT_COOKIE_DAYS, ROOT_DOMAIN);
          this.setCookie(
            COOKIE.optanonAlertBoxClosed,
            vfConsentClosed,
            CONSENT_COOKIE_DAYS,
            ROOT_DOMAIN
          );
        },

        loadTagManager(win, doc, dataLayerName, containerId) {
          win[dataLayerName] = win[dataLayerName] || [];
          win[dataLayerName].push({ start: new Date().getTime(), event: 'stg.start' });

          const scripts = doc.getElementsByTagName('script')[0];
          const tag = doc.createElement('script');

          function stgCreateCookie(name, value, days) {
            let expires = '';
            if (days) {
              const date = new Date();
              date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
              expires = `; expires=${date.toUTCString()}`;
            }
            doc.cookie = `${name}=${value}${expires}; path=/`;
          }

          const isStgDebug =
            (win.location.href.match('stg_debug') || doc.cookie.match('stg_debug')) &&
            !win.location.href.match('stg_disable_debug');
          stgCreateCookie('stg_debug', isStgDebug ? 1 : '', isStgDebug ? 14 : -1);

          const query = [];
          if (dataLayerName !== 'dataLayer') {
            query.push(`data_layer_name=${dataLayerName}`);
          }
          if (isStgDebug) {
            query.push('stg_debug');
          }
          const queryString = query.length > 0 ? `?${query.join('&')}` : '';

          tag.async = true;
          tag.src = `https://vattenfall.containers.piwik.pro/${containerId}.js${queryString}`;
          scripts.parentNode.insertBefore(tag, scripts);

          (function (a, n, apis) {
            a[n] = a[n] || {};
            for (let i = 0; i < apis.length; i++) {
              (function (apiName) {
                a[n][apiName] = a[n][apiName] || {};
                a[n][apiName].api =
                  a[n][apiName].api ||
                  function () {
                    const args = [].slice.call(arguments, 0);
                    if (typeof args[0] === 'string') {
                      win[dataLayerName].push({
                        event: `${n}.${apiName}:${args[0]}`,
                        parameters: [].slice.call(arguments, 1)
                      });
                    }
                  };
              })(apis[i]);
            }
          })(win, 'ppms', ['tm', 'cm']);
        }
      };

      window.ot_loader.migrateConsentCookies();
      window.ot_loader.loadOneTrust();
      window.ot_loader?.loadTagManager(window, document, 'dataLayer', ot_loader.getContainerId());
    }
  }
}
</script>

<style scoped>
.cso-marketing {
  display: none;
}
</style>
